import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGetApi } from "../../../hooks/useGetApi";
import { getBillingByIdApi } from "../../../services/billing.service";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { confirmDischargeByVisitIdApi } from "../../../services/consultation.service";
import { toast } from "react-toastify";

const ConfirmDischargeModal = ({ open, onClose, selectedRow }) => {
  const id = selectedRow?.occupancyDetails?.patientId;
  const visitId = selectedRow?.occupancyDetails?.visitId;
  const [loading, setLoading] = useState(false);
  const [isunPaid, setIsUnPaid] = useState([]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data } = await getBillingByIdApi({ id });
    setLoading(false);
    const invoices = Array.isArray(data?.invoices) ? data.invoices : [];
    if (invoices.length === 0) {
      toast.error("No bills found!");
      return;
    }
    const unpaidInvoices = invoices.filter(
      (invoice) => invoice?.amountToBePaid !== 0
    );

    if (unpaidInvoices.length > 0) {
      setIsUnPaid(unpaidInvoices);
      toast.error("Bill not cleared yet");
    } else {
      setLoading(true);
      const result = await confirmDischargeByVisitIdApi(visitId, {
        closeBill: true,
      });
      setLoading(false);
      if (result.code === 200 || result.code === 201) {
        toast.success("Discharged confirm Successfully!");
        onClose();
        setIsUnPaid([]);
      } else {
        toast.error(result?.message || "Some error occurred!");
      }
    }
  };
  useEffect(() => {
    setIsUnPaid([]);
  }, [onClose]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
            width: "40vw",
            height: "300px",
          },
        },
      }}
    >
      <DialogContent sx={{ display: "grid", placeItems: "center" }}>
        {isunPaid.length > 0 ? (
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <ErrorOutlineIcon
                sx={{ color: "rgba(224, 7, 0, 1)", fontSize: "100px" }}
              />
              <Typography variant="h5">Bill Can't Be Closed</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ color: "rgba(224, 7, 0, 1)", my: "20px" }}>
                Note: Clear Payments to Close bill and confirm Discharge.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="outlined"
                sx={{ width: "150px" }}
                onClick={onClose}
              >
                Okay
              </Button>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              textAlign: "center",
              alignItems: "center",
            }}
            component={"form"}
            onSubmit={submitHandler}
          >
            <Box>
              <Typography variant="h5">Are You Sure You Want To</Typography>
              <Typography variant="h5">Confirm Discharge?</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox />
              <Typography>Bill Can Be Closed</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              <Button
                variant="outlined"
                sx={{ width: "150px" }}
                onClick={onClose}
              >
                No
              </Button>
              <Button
                variant="outlined"
                type="submit"
                sx={{ width: "150px" }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={"24px"} /> : "Yes"}
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDischargeModal;
